import { combineReducers } from 'redux';
import {L_INIT_STATE, layerReducer, LayerState} from './layer.reducer';


export interface IAppState {
  layergroup: LayerState;
}

export const INITIAL_STATE: IAppState = {
  layergroup: L_INIT_STATE
};

export const rootReducer = combineReducers<IAppState>({
  layergroup: layerReducer
});



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/reducers/root.reducer.ts